export function emptyFunc(): void {
  return undefined;
}

export async function emptyAsyncFunc(): Promise<void> {
  return undefined;
}

export async function errorDelay(): Promise<void> {
  await new Promise((resolve, reject) => setTimeout(reject, 500));
}

export async function successDelay(): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 500));
}
